import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import {
    EuiIconModule,
    EuiButtonModule,
} from '../../components';

import { EuiUserProfileModule } from '../eui-user-profile/user-profile.module';
import { EuiSearchModule } from '../eui-search/search.module';
import { EuiNotificationsModule } from '../eui-notifications/eui-notifications.module';

import { EuiToolbarComponent } from './toolbar.component';
import { EuiToolbarItemsComponent } from './toolbar-items/toolbar-items.component';
import { EuiToolbarItemComponent } from './toolbar-item/toolbar-item.component';
import { EuiToolbarItemUserProfileComponent } from './toolbar-item-user-profile/toolbar-item-user-profile.component';
import { EuiToolbarItemSearchComponent } from './toolbar-item-search/toolbar-item-search.component';
import { EuiToolbarItemNotificationsComponent } from './toolbar-item-notifications/toolbar-item-notifications.component';
import { EuiToolbarLogoComponent } from './toolbar-logo/toolbar-logo.component';
import { EuiToolbarAppComponent } from './toolbar-app/toolbar-app.component';
import { EuiToolbarEnvironmentComponent } from './toolbar-environment/toolbar-environment.component';
import { EuiLanguageSelectorModule } from '../eui-language-selector';

const COMPONENTS = [
    EuiToolbarComponent,
    EuiToolbarItemComponent,
    EuiToolbarItemsComponent,
    EuiToolbarItemUserProfileComponent,
    EuiToolbarItemSearchComponent,
    EuiToolbarItemNotificationsComponent,
    EuiToolbarLogoComponent,
    EuiToolbarAppComponent,
    EuiToolbarEnvironmentComponent,
];

@NgModule({
    imports: [
        CommonModule,
        EuiIconModule,
        EuiButtonModule,
        EuiUserProfileModule,
        EuiSearchModule,
        EuiNotificationsModule,
        EuiLanguageSelectorModule,
    ],
    declarations: [
        ...COMPONENTS,
    ],
    exports: [
        ...COMPONENTS,
    ],
})
export class EuiToolbarModule { }
